/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseExtrasInner
 */
export interface GetReportTab200ResponseExtrasInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseExtrasInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseExtrasInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseExtrasInner
     */
    value: number;
}

/**
 * Check if a given object implements the GetReportTab200ResponseExtrasInner interface.
 */
export function instanceOfGetReportTab200ResponseExtrasInner(value: object): value is GetReportTab200ResponseExtrasInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseExtrasInnerFromJSON(json: any): GetReportTab200ResponseExtrasInner {
    return GetReportTab200ResponseExtrasInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseExtrasInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseExtrasInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'value': json['value'],
    };
}

export function GetReportTab200ResponseExtrasInnerToJSON(json: any): GetReportTab200ResponseExtrasInner {
    return GetReportTab200ResponseExtrasInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseExtrasInnerToJSONTyped(value?: GetReportTab200ResponseExtrasInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'value': value['value'],
    };
}

